import { render, staticRenderFns } from "./ShopifyOrder.vue?vue&type=template&id=2b4872d2&scoped=true"
import script from "./ShopifyOrder.vue?vue&type=script&lang=js"
export * from "./ShopifyOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4872d2",
  null
  
)

export default component.exports